/*
InputType = "radio" | "checkbox" | "string"
Comparator = "eq" | "neq" | "geq" | "leq" | "lt" | "gt" | (object, property, FilterValue) => boolean
InputField {
    label: string,
    value: any
}

interface FilterSpec {
    title: string,
    inputType: InputType,
    inputFields: InputField[]
    filteredObjectProperty: string | number
    comparator: Comparator
}
*/

const getUniqueValuesForAttribute = (arr, attribute) =>
  arr
    ?.map(elem => elem[attribute]?.trim())
    .filter((value, index, self) => self.indexOf(value) === index)
    .filter(a => a)

const FilterLabeledInput = props => {
  const { title, value, inputType, updateFiltersAndLocations, isSelected = false } = props
  const name = `filter-labled-input-${title}`
  const id = `${name}-${value}`

  return (
    <div>
      <input
        id={id}
        value={value}
        checked={isSelected}
        type={inputType}
        onChange={() => {
          updateFiltersAndLocations(title, value)
        }}
        name={name}
      />

      <label htmlFor={id} className={'control-label px-2'}>
        {value}
      </label>
    </div>
  )
}

const FilterCard = props => {
  const { options, filter, updateFiltersAndLocations } = props
  return (
    <div className={'filter-list-container g-col-4 my-1'}>
      <div className={'d-flex justify-content-between'}>
        <span className="lead">{filter.title}</span>
        <input
          type="reset"
          value="clear"
          onClick={() => {
            updateFiltersAndLocations(filter.title, '')
          }}
          className={'d-inline bg-light'}
          style={{ border: 'grey', fontSize: 'revert' }}
        />
      </div>
      {options
        ?.sort((a, b) => a.localeCompare(b))
        .map(inputField => {
          return <FilterLabeledInput isSelected={filter.selection === inputField} value={inputField} {...filter} updateFiltersAndLocations={updateFiltersAndLocations} key={inputField} />
        })}
    </div>
  )
}

const FilterBanner = props => {
  const { data, filters, updateFiltersAndLocations, filterHeading, searchValue, showSearch } = props
  return (
    <div>
        <div className={'filter-block my-1'}>
          <div className={filterHeading ? 'lead' : 'd-none'}>Filters</div>
          {showSearch && (
            <div className={'g-col-4 mb-3'}>
              <span className="lead">Search</span>
              <div className={'d-flex justify-content-between'}>
                <input
                  value={searchValue}
                  type="text"
                  onChange={e => {
                    e.preventDefault()
                    updateFiltersAndLocations('search', '', e.target.value)
                  }}
                  className="form-control appended-form-control rounded-pill"
                />
              </div>
            </div>
          )}
          {filters?.map(filter => (
            <FilterCard data={data} updateFiltersAndLocations={updateFiltersAndLocations} metric={filter.filteredObjectProperty} filter={filter} options={getUniqueValuesForAttribute(data, filter.filteredObjectProperty)} key={filter.title} />
          ))}
      </div>
    </div>
  )
}

const FilterCardSlim = props => {
  const { options, filter, updateFiltersAndLocations } = props
  return (
    <div>
      <div className={'d-flex justify-content-between'}>
        <span className="lead">{filter.title}</span>
      </div>
      <select
        name={filter.title}
        onChange={e => {
          e.preventDefault()
          if (e.target.value === 'all') {
            updateFiltersAndLocations(filter.title, '')
          } else {
            updateFiltersAndLocations(filter.title, e.target.value)
          }
        }}
      >
        <option value="all">Show All</option>
        {options
          ?.sort((a, b) => a.localeCompare(b))
          ?.map(inputField => {
            return (
              <option key={`filter-labled-input-${inputField}-${inputField}`} value={inputField}>
                {inputField}
              </option>
            )
          })}
      </select>
    </div>
  )
}

const FilterBannerSlim = props => {
  const { data, filters = [], updateFiltersAndLocations, searchValue, showSearch } = props
  const colSize = 12 / (filters.length + 1)
  return (
    <div>
      <div className={`filter-block my-1 grid`}>
      {showSearch && (
        <div className={`mb-3  g-col-12 g-col-md-${colSize}`}>
          <span className="lead">Search</span>
          <div className={'d-flex justify-content-between'}>
            <input
              value={searchValue}
              type="text"
              onChange={e => {
                e.preventDefault()
                updateFiltersAndLocations('search', '', e.target.value)
              }}
              className="form-control appended-form-control rounded-pill"
            />
          </div>
        </div>
      )}
        {filters?.map(filter => (
          <div key={filter.title} className={`filter-list-container-slim g-col-12 g-col-md-${colSize} my-1`}>
            <FilterCardSlim data={data} updateFiltersAndLocations={updateFiltersAndLocations} metric={filter.filteredObjectProperty} filter={filter} options={getUniqueValuesForAttribute(data, filter.filteredObjectProperty)} />
          </div>
        ))}
      </div>
    </div>
  )
}

export { FilterBanner, FilterBannerSlim }